import React from "react";
import styles from "../Floors.module.css";
import Skeleton from "react-loading-skeleton";

const FloorsSkeleton = () => {
  return (
    <div className={styles.FloorsContainer}>
      <div className={styles.Floors}>
        {Array.apply(0, Array(3)).map((n, i) => (
            <Skeleton key={i} height={46} width={200} style={{margin: "0 10px" }}/>
        ))}
      </div>
    </div>
  );
};

export default FloorsSkeleton;
